import type { SVGProps } from "react";
export interface ShrimpIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ShrimpIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ShrimpIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M16.205 11.705a1.125 1.125 0 1 1 1.59 1.59l-1 1a1 1 0 0 1-.09.08h1.296l.114.006a1.125 1.125 0 0 1 0 2.238l-.114.006h-1.5a1.125 1.125 0 0 1-1.126-1.125c0-.365.175-.687.444-.892a1.1 1.1 0 0 1-.615-.312 1.125 1.125 0 0 1 0-1.59zM13.875 9.5a1.125 1.125 0 0 1 2.25 0c0 1.088-.523 2.222-1.293 3.069-.783.862-1.942 1.555-3.333 1.555a1.125 1.125 0 0 1 0-2.25c.61 0 1.202-.305 1.669-.818.48-.529.708-1.145.708-1.556ZM9.504 7.375l.114.005a1.126 1.126 0 0 1 0 2.239l-.114.006h-.006a1.125 1.125 0 0 1 0-2.25zM.875 3.75A2.876 2.876 0 0 1 3.75.875H10l.115.006a1.125 1.125 0 0 1 0 2.238L10 3.125H3.75a.626.626 0 0 0 0 1.25H4l.115.005a1.125 1.125 0 0 1 0 2.239L4 6.625h-.25A2.875 2.875 0 0 1 .875 3.75"
      />
      <path
        fill={color}
        d="M20.875 13.25a6.626 6.626 0 0 0-6.626-6.625H5.28c.243.987.763 2.1 1.494 3.075 1.053 1.404 2.262 2.175 3.226 2.175h4a3.625 3.625 0 0 1 0 7.25h-.876v.75h1.125a6.625 6.625 0 0 0 6.626-6.624Zm2.25 0a8.875 8.875 0 0 1-8.876 8.875h-2.11l-3.866.966a1.125 1.125 0 0 1-1.376-1.312v-.003l.002-.003.001-.01.008-.033.023-.104a6.6 6.6 0 0 1 .5-1.38c.107-.215.263-.48.468-.747a4.6 4.6 0 0 1-.468-.747 6.6 6.6 0 0 1-.5-1.38l-.023-.102-.008-.032-.001-.01-.002-.005v-.001L8 17l-1.103.22a1.124 1.124 0 0 1 1.376-1.31l3.866.965H14a1.374 1.374 0 0 0 0-2.75h-4c-2.036 0-3.827-1.479-5.024-3.075C3.755 9.422 2.875 7.315 2.875 5.5l.006-.116A1.125 1.125 0 0 1 4 4.374l10.25.001a8.876 8.876 0 0 1 8.875 8.876Z"
      />
    </svg>
  );
}
